<template>
    <div id="page_header">
        <div class="page_container container">
            <div id="logo">
                <img src="./assets/images/logo.jpg" height="60"/>
            </div>
            <div id="top_nav">
                <ul class="flex-c">
                    <li> 全球服务 互惠共享</li>
<!--                    <li class="link_black">-->
<!--                        <router-link to="./franchise">加盟合作</router-link>-->
<!--                    </li>-->
                    <li class="link_black">
                        <router-link to="./about">关于我们</router-link>
                    </li>
<!--                    <li class="link_black">-->
<!--                        <router-link to="./serve">服务大厅</router-link>-->
<!--                    </li>-->
                </ul>
            </div>
        </div>
    </div>
    <div class="page_container">

        <router-view></router-view>

        <div id="footer">
            <div id="footer_line"></div>
            <div id="footer_text" class="mc">
                版权所属&copy; 北京慧通视远国际文化传媒有限公司<br/>
                <a href="https://beian.miit.gov.cn">京ICP备17056545号 </a><br/>
                战略合作：17610530838 何老师 <br/>


            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {}
    }
</script>
<script setup>
    /*JavaScript*/
</script>
<style>
    #app {
        background-color: #ffffff;
        margin: 0 auto;
        position: relative;

    }

    .page_container {
        position:relative;
        max-width: 1440px;
        margin: 0 auto;

    }

    #page_header {
        /*background-color: #f0f0f4;*/
        height: 75px;
        background-image: linear-gradient(180deg,#f7f8f3, #ffffff);

    }

    #logo {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0 0 0 3px;
        opacity: 0.8;
        padding-top:15px;

    }

    #top_nav {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 3;
        padding: 10px 20px;
        background-color: white;
        border-radius: 0 0 10px 10px;
        margin: 0 20px;
        box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
        font-size: 14px;

    }

    #top_nav ul li::after {
        content: '|'; /* 竖线的内容 */
        margin: 0 8px; /* 根据需要调整间距 */
    }

    #top_nav ul li:last-child::after {
        content: none; /* 移除最后一个列表项后的竖线 */
    }

    /*页脚*/
    #footer {
        height: 160px;
        background-color: #f2f3f4
    }

    #footer_line {
        height: 5px;
        background-color: #0E8A3B;
        margin: 0 0 20px 0;
    }

    #footer_text {
        height: 155px;
        width: 800px;
        text-align: center;
        line-height: 2rem
    }
</style>
